import { useEffect } from 'react';
import { useAsyncAction } from 'Hooks/Common';
import {
  useDocumentFieldsMetaChange,
  useDocumentFieldStyleSet,
} from 'Hooks/DocumentFields';
import { useRequisitesGet } from 'Hooks/Requisite';
import { NormalizedEntity } from 'Interfaces/Common';
import { Document } from 'Interfaces/Document';
import { Requisite } from 'Interfaces/Requisite';
import { isNotEmpty } from 'Utils/functions';

import { useCompatibleSignedGetUrl } from '../User';

export default (document?: Document) => {
  const [setDocumentFieldsMeta, cleanDocumentFieldsMeta] = useDocumentFieldsMetaChange();
  const [getUserRequisites] = useRequisitesGet();
  const [getCompatibleSignedGetUrl] = useCompatibleSignedGetUrl();
  const setDocumentFieldStyle = useDocumentFieldStyleSet();

  useEffect(() => {
    if (!document) return () => {};

    setDocumentFieldsMeta({ currentDocumentId: document.id });
    document.fields.forEach(setDocumentFieldStyle);

    return () => cleanDocumentFieldsMeta();
  }, [cleanDocumentFieldsMeta, document, setDocumentFieldStyle, setDocumentFieldsMeta]);

  return useAsyncAction(() => {
    if (!document) return [];

    const fileKey =
      isNotEmpty(document.files) && document.files && document.files[0].fileKey;
    const key = fileKey ? fileKey : (document.pdfFileKey as string);

    // @ts-ignore
    return Promise.all([
      getCompatibleSignedGetUrl({ key, pdfFileKey: document.pdfFileKey }),
      getUserRequisites(undefined),
    ]).then(res => res.flat()) as [
      { result: string },
      string[],
      {} | NormalizedEntity<Requisite>,
    ];
  });
};
